/**
 * 定位设备一览模块
 * 创建时间：2017-04-26
 * 创建人：baixx
 */
<template>	
		<div id="posdevice-list" class="wrapper wrapper-content fadeInRight animated tabBox">
		   <div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
			<div class="form-horizontal">
				<div class="form-group">
					<label class="col-sm-1 control-label">设备ID</label>
					<div class="col-sm-2">
						<input class="form-control" v-model.trim="queryParam.deviceId" maxlength="10">
					</div>
					<label class="col-sm-1 control-label">设备编号</label>
					<div class="col-sm-2">
						<input type="text" class="form-control" v-model.trim="queryParam.deviceNum" maxlength="20">
					</div>
					<label class="col-sm-1 control-label">品牌</label>
					<div class="col-sm-2">
						<select class="form-control" v-model="queryParam.brandCode">
							<option v-for="brand in deviceBrand" :value="brand.brandCode">
								{{brand.brandName}}
							</option>
						</select>
					</div>
					<label class="col-sm-1 control-label">型号</label>
					<div class="col-sm-2">
						<select class="form-control" v-model="queryParam.categoryNo">
							<option v-for="model in deviceCategory" :value="model.id">
								{{model.categoryNo}}
							</option>
						</select>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-1 control-label">充值起始时间</label>
					<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validRechargeDates }">
						<datepicker v-model="queryParam.expiredDateBegin" class="form-control" ref="dateRechargeFrom"></datepicker>
						<p v-if="!validRechargeDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
					</div>
					<label class="col-sm-1 control-label">充值结束时间</label>
					<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validRechargeDates }">
						<datepicker v-model="queryParam.expiredDateEnd" class="form-control" ref="dateRechargeTo"></datepicker>
		                <p v-if="!validRechargeDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
					</div>
					<label class="col-sm-1 control-label">安装起始时间</label>
					<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validInstallDates }">
						<datepicker v-model="queryParam.installDateBegin" class="form-control" ref="dateInstallFrom"></datepicker>
						<p v-if="!validInstallDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
					</div>
					<label class="col-sm-1 control-label">安装结束时间</label>
					<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validInstallDates }">
						<datepicker v-model="queryParam.installDateEnd" class="form-control" ref="dateInstallTo"></datepicker>
		                <p v-if="!validInstallDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
					</div>
				</div>		
				<div class="form-group">
					<label class="col-sm-1 control-label">有线无线</label>
					<div class="col-sm-2">
						<select class="form-control" v-model="queryParam.wifiFlag">
							<option v-for="wifiFlag in wifiFlagList" :value="wifiFlag.udccode">
								{{wifiFlag.udcname}}
							</option>
						</select>
					</div>
					<label class="col-sm-1 control-label">所属服务号</label>
					<div class="col-sm-2">
						<input type="text" class="form-control" v-model.trim="queryParam.vehicleAccount" maxlength="20">
					</div>
					<label class="col-sm-1 control-label">车牌号</label>
					<div class="col-sm-2">
						<vplate-input type="text" class="form-control" v-model.trim="queryParam.plateNumber" maxlength="10"/>
					</div>
					<label class="col-sm-1 control-label">SIM卡号</label>
					<div class="col-sm-2">
						<input type="text" class="form-control" v-model.trim="queryParam.simNum" maxlength="13">
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-1 control-label">运营商</label>
					<div class="col-sm-2">
						<select class="form-control" v-model="queryParam.simOperators">
							<option v-for="operator in operatorList" :value="operator.udccode">{{operator.udcname}}</option>
						</select>
					</div>
					<label class="col-sm-1 control-label">卡类型</label>
					<div class="col-sm-2">
						<select class="form-control" v-model="queryParam.simType" maxlength="11">
							<option v-for="cardType in cardTypeList" :value="cardType.udccode">{{cardType.udcname}}</option>
						</select>
					</div>
					<label class="col-sm-1 control-label">安装人</label>
					<div class="col-sm-2">
						<input type="text" class="form-control" v-model.trim="queryParam.installer" maxlength="10">
					</div>
					<!--<label class="col-sm-1 control-label">设备类型</label>
					<div class="col-sm-2">
						<select class="form-control" v-model="queryParam.deviceType">
							<option v-for="obdFlag in OBDFlagList" :value="obdFlag.udccode">
								{{obdFlag.udcname}}
							</option>
						</select>
					</div>-->
				</div>
				<div class="form-group">
				    <div class="col-sm-12 text-right">
				    	<button type="button" class="btn btn-primary" @click="resetQueryParams">重置</button>
						<button type="button" class="btn btn-primary" @click="searchInfo" :disabled="!validRechargeDates ||!validInstallDates">查询</button>
					</div>
				</div>	
				<div class="form-group">
					<div class="col-sm-12 text-right">
						<button @click="sentDirective" type="button" class="btn btn-primary">批量发送指令</button>
					</div>
				</div>
				<div class="hr-line-dashed"></div>
				<div class="form-group">
					<div class="col-sm-12 text-left">
						<button type="button" v-show="!checkBox" class="btn btn-primary" @click="selectModel">复选模式</button>
						<button type="button" v-show="checkBox" class="btn btn-primary" @click="selectModel">关闭模式</button>
						<button type="button" v-show="checkBox" class="btn btn-primary" @click="selectAllField">全选</button>
						<button type="button" v-show="checkBox" class="btn btn-primary" @click="selectRevertField">反选</button>
					</div>
				</div>
			</div>
			<!--表格开始-->
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-hover">
					<thead>
						<tr role="row">
							<th v-if="checkBox"></th>
							<th>设备ID</th>
							<th>设备编码</th>
							<th>品牌</th>
							<th>型号</th>
							<th>充值到期时间</th>
							<th>安装时间_起</th>
							<th>安装人</th>
							<th>车牌号</th>
							<th>SIM卡号</th>
							<th>运营商</th>
							<th>卡类型</th>
							<th>服务卡号</th>
							<th>车辆ID</th>
							<th>有线无线</th>
							<th></th>
						</tr>
					</thead>
					<transition-group name="list-complete" tag="tbody">
						<tr v-for="(fileInfo,index) in fileInfoList" v-bind:key="index + 'posdevicelist'">
							<td v-if="checkBox" class="text-center">
								<input style="margin-top:0px;" type="checkbox" v-model="posDeviceSelectArr" :value="fileInfo">
							</td>
							<td>VD{{fileInfo.deviceId}}</td>
							<td>{{fileInfo.deviceNum}}</td>
							<td>{{fileInfo.brandName}}</td>
							<td>{{fileInfo.categoryName}}</td>
							<td>{{fileInfo.expiredDate}}</td>
							<td>{{fileInfo.installDate}}</td>
							<td>{{fileInfo.installer}}</td>
							<td>{{fileInfo.plateNumber}}</td>
							<td>{{fileInfo.simNum}}</td>
							<td>{{fileInfo.simOperators}}</td>
							<td>{{fileInfo.simTypeName}}</td>
							<td>{{fileInfo.vehicleAccount}}</td>
							<td>VE{{fileInfo.vehicleId}}</td>
							<td>{{fileInfo.wifiFlagName}}</td>
							<td class="text-center">
								<a v-if="permission.indexOf('posDeviceList_deviceDetail') == -1" @click="addDeviceTab(fileInfo.deviceId,fileInfo.deviceNum,fileInfo.obdFlagName,fileInfo.vehicleId)">设备详情</a>
								<a v-if="permission.indexOf('posDeviceList_carDetail') == -1" @click="openDidiCarFile(fileInfo.plateNumber,fileInfo.vehicleId)">车辆详情</a>
							</td>
						</tr>
					</transition-group>
				</table>
			</div>
			 <pagination v-if="fileInfoList.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
			</div>
			
		   	<!--弹出框子组件-->
			<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
				{{messageStr}}
				<div slot="footer">
			        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
			    </div>
			</tab-modal>
			
			<!--指令发送组件-->
			<tab-modal ref="directiveModal" size="middle" :scroll='scrollTop' title="指令下发" v-on:cancel="closeDirectiveModal">
				<div v-show="stepIndex==1">
					<div class="form-group" >
					    <label>请选择指令</label>
					    <select class="form-control" v-model="selectCmd">
							<option v-for="option in cmdList" v-bind:value="option">
								{{ option.cmdName }}
							</option>
						</select>
					</div>
					<div slot="footer" class="text-right">
						 <button @click="backToFirst" class="btn btn-primary">取消</button>
			        	<button @click="nextstep" class="btn btn-primary">下一步</button>
					</div>
				</div>
				<div v-show="stepIndex==2">
					<div>
						<component :is="selectCmd.winId" ref="instComp" :from="device" :delCmd="delCmd" v-on:withdrawBtn="cancelCmd" v-on:nextClick="nextCmd"></component>
					</div>
				</div>
				<div v-show="stepIndex==3">
					<div>
						您将要发送{{selectCmd.cmdName}}指令，发送至{{sentCount.length}}个定位设备。
					</div>
					<div slot="footer" class="text-right">
				        <button  @click="stopSend" class="btn btn-primary">取消</button>
				        <button  @click="confirmToSend" class="btn btn-primary">确定</button>
				    </div>
				</div>
			</tab-modal>
		</div>
</template>

<script>
    import Pagination from 'components/common/Pagination'
    import TabModal from 'components/common/TabModal'
	import Datepicker from 'components/common/datepicker/Datepicker'
    import { OPERATE_SUCCESS, OPERATE_EXCEPTION } from 'static/message'
    import {DICTIONARY_MAP} from 'static/constant'
    import {getDictionaryFromArray} from 'util/util'
    import classlist from 'util/classlist'
    import {goTabMixin} from 'util/util'
    import InsGoloxLoading from 'components/pages/vehiclemonitor/instructions/InsGoloxLoading'
	import InsGoloxObd from 'components/pages/vehiclemonitor/instructions/InsGoloxObd'
	import InsGoloxWifi from 'components/pages/vehiclemonitor/instructions/InsGoloxWifi'
	import InsGT02BLbsPosition from 'components/pages/vehiclemonitor/instructions/InsGT02BLbsPosition'
	import InsGT02LbsPosition from 'components/pages/vehiclemonitor/instructions/InsGT02LbsPosition'
	import InsGT520CaliMile from 'components/pages/vehiclemonitor/instructions/InsGT520CaliMile'
	import InsGT520CaliVehicles from 'components/pages/vehiclemonitor/instructions/InsGT520CaliVehicles'
	import InsGT520Port from 'components/pages/vehiclemonitor/instructions/InsGT520Port'
	import InsGT750Port from 'components/pages/vehiclemonitor/instructions/InsGT750Port'
	import InsMG50CaliMile from 'components/pages/vehiclemonitor/instructions/InsMG50CaliMile'
	import InsMG50CaliVehicles from 'components/pages/vehiclemonitor/instructions/InsMG50CaliVehicles'
	import InsMG50Port from 'components/pages/vehiclemonitor/instructions/InsMG50Port'
	import InsOCARCaliMile from 'components/pages/vehiclemonitor/instructions/InsOCARCaliMile'
	import InsOCARObd from 'components/pages/vehiclemonitor/instructions/InsOCARObd'
	import InsOCARPort from 'components/pages/vehiclemonitor/instructions/InsOCARPort'
	
	import InsBKAlarmClock from 'components/pages/vehiclemonitor/instructions/InsBKAlarmClock'
	import InsBKMonitor from 'components/pages/vehiclemonitor/instructions/InsBKMonitor'
	import InsBKAPN from 'components/pages/vehiclemonitor/instructions/InsBKAPN'
	import InsBKPort from 'components/pages/vehiclemonitor/instructions/InsBKPort'
	import InsBKTrack from 'components/pages/vehiclemonitor/instructions/InsBKTrack'
	
	import InsGT740AlarmClockModeSet from 'components/pages/vehiclemonitor/instructions/InsGT740AlarmClockModeSet'
	import InsGT740DefaultedModeSet from 'components/pages/vehiclemonitor/instructions/InsGT740DefaultedModeSet'
	import InsGT740GSMOpenSet from 'components/pages/vehiclemonitor/instructions/InsGT740GSMOpenSet'
	import InsGT740LowPowerAlarm from 'components/pages/vehiclemonitor/instructions/InsGT740LowPowerAlarm'
	import InsGT740VibrationAlarmSet from 'components/pages/vehiclemonitor/instructions/InsGT740VibrationAlarmSet'
	import InsGT740WeekModeSet from 'components/pages/vehiclemonitor/instructions/InsGT740WeekModeSet'
	import InsGT420setWorkMode from 'components/pages/vehiclemonitor/instructions/InsGT420setWorkMode'
	
	import InsCustomized from 'components/pages/vehiclemonitor/instructions/InsCustomized'
	export default {
		name: 'PagePosDeviceList',
		mixins:[goTabMixin],
		components: {
			Pagination,
			TabModal,
			Datepicker,
			InsGoloxLoading,
			InsGoloxObd,
			InsGoloxWifi,
			InsGT02BLbsPosition,
			InsGT02LbsPosition,
			InsGT520CaliMile,
			InsGT520CaliVehicles,
			InsGT520Port,
			InsGT750Port,
			InsMG50CaliMile,
			InsMG50CaliVehicles,
			InsMG50Port,
			InsOCARCaliMile,
			InsOCARObd,
			InsOCARPort,
			InsBKAlarmClock,
			InsBKMonitor,
			InsBKTrack,
			InsBKPort,
			InsBKAPN,
			InsGT740AlarmClockModeSet,
			InsGT740DefaultedModeSet,
			InsGT740GSMOpenSet,
			InsGT740LowPowerAlarm,
			InsGT740VibrationAlarmSet,
			InsGT740WeekModeSet,
			InsCustomized,
			InsGT420setWorkMode
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["posDeviceList"]?this.$store.state.permission.permission["posDeviceList"]:[],
				loadingstatus:false,
				fileInfoList:[],										// 查询结果
				posDeviceSelectArr:[],                                  // 定位设备信息全选
				deviceTypeArr:[],
				checkBox:false,
				pageInfo:{},
				queryParam:{											// 查询参数
					deviceId: "",										// 设备ID
					deviceNum: "",							            // 设备编号
					deviceType: "",                                     // 设备类型
					brandCode: "",		                                // 品牌分组ID
					categoryNo: "",		                                // 型号分组ID
					expiredDateBegin: "",								// 充值起始时间
					expiredDateEnd: "",								    // 充值结束时间
					installDateBegin: "" ,								// 安装起始时间
					installDateEnd: "" ,								// 安装结束时间
					wifiFlag: "",                                       // 有线无线
					vehicleAccount: "",                                 // 所属服务卡号 
					plateNumber: "",                                    // 所属车辆
					simNum: "",                                         // SIM卡号
					simOperators: "",                                   // 运营商分组ID
					simType: "",	                                    // 卡类型分组ID
					installer: "",                                      // 安装人
					page_index: 1,                                      // 当前第几页
				},
				deviceBrand:[],										    //设备品牌下拉
				deviceCategory:[],										//设备类型下拉
				operatorList:[],                                        // 运营商 下拉
				cardTypeList:[],                                        // 卡类型信息下拉
				wifiFlagList:[], 										 // 有线无线下拉
				OBDFlagList :[],										//设备类型下拉
				selectCmd:{},											//已经选择的指令
				sentCount:[],											//发送数量
				cmdList :[],											//批量命令列表
				deviceList :[],											//批量设备列表
				stepIndex:1,                      						//当前步骤索引
				messageStr: "",					                        // 弹出框内容	
				scrollTop: '0',
				device:'device',										//传给指令窗口的参数
				paramCmd:'',											//从指令窗口传来的参数
				delCmd:false,											//点击了取消按钮，需要清空指令输入框
				sendTime:0	 											//发送了‘InsOCARCaliMile’次数
			};
		},
		beforeMount(){
			this.getUdc();
			//初始化信息
			this.getTableInfo();
			//获得品牌信息
			this.getDeviceBrand();
			
		},
		watch:{
			'queryParam.brandCode'(){
				this.getDeviceCategory();
			}
		},
		computed: {
			//充值起止时间是否合法
			validRechargeDates: function(){
				if(this.queryParam.expiredDateBegin && this.queryParam.expiredDateEnd && this.queryParam.expiredDateBegin > this.queryParam.expiredDateEnd){
					return false;
				} else {
					return true;
				}
			},
			//安装起止时间是否合法
			validInstallDates: function(){
				if(this.queryParam.installDateBegin && this.queryParam.installDateEnd && this.queryParam.installDateBegin > this.queryParam.installDateEnd){
					return false;
				} else {
					return true;
				}
			}
		},
		methods:{
			//查询方法
			searchInfo(){
				this.queryParam.page_index = 1;
				this.getTableInfo();
			},
			//初始化信息
			getTableInfo:function(){
				this.loadingstatus = true;
				this.$http.get(process.env.API_ROOT + '/vehicle/devices/', {params: this.queryParam})
				.then( res => {
					if(res.body.success){
						const resInfo = res.body.data;								
						const {pageNum,pages,total,isFirstPage,isLastPage} = resInfo;
						this.pageInfo = {
							pageNum: pageNum,
							pages: pages,
							total: total,
							isFirstPage: isFirstPage,
							isLastPage: isLastPage
						}
						this.fileInfoList = resInfo.list;
						this.loadingstatus = false;
					} else {
						this.openModalMsg(res.body.message);
						this.loadingstatus = false;
					}
				}, res => {
					this.openModalMsg(res.body.message);
					this.loadingstatus = false;
				}).catch( res => {
					this.openModalMsg(OPERATE_EXCEPTION);
					this.loadingstatus = false;
				})
			},
			//重置信息
			resetQueryParams:function(){
				this.$refs.dateRechargeFrom.handleClear();
				this.$refs.dateRechargeTo.handleClear();
				this.$refs.dateInstallFrom.handleClear();
				this.$refs.dateInstallTo.handleClear();
				this.queryParam = {
					deviceId: "",										// 设备ID
					deviceNum: "",							            // 设备编号
					deviceType: "",                                     // 设备类型
					brandCode: "",		                                // 品牌分组ID
					categoryNo: "",		                                // 型号分组ID
					expiredDateBegin: "",								// 充值起始时间
					expiredDateEnd: "",								    // 充值结束时间
					installDateBegin: "" ,								// 安装起始时间
					installDateEnd: "" ,								// 安装结束时间
					wifiFlag: "",                                       // 有线无线
					vehicleAccount: "",                                 // 所属服务卡号 
					plateNumber: "",                                    // 所属车辆
					simNum: "",                                         // SIM卡号
					simOperators: "",                                   // 运营商分组ID
					simType: "",	                                    // 卡类型分组ID
					installer: "",                                      // 安装人
					page_index: 1,                                      // 当前第几页
				}
			},
			// 获取设备品牌下拉列表
			getDeviceBrand(){
				this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/devices/brands')
				.then( res => {
					if(res.data.success){
						this.deviceBrand= res.data.data;
					}else{
						this.openModalMsg(res.body.message);
					}
				}, res => {
						this.openModalMsg(res.body.message);
				}).catch( res => {
					this.openModalMsg(OPERATE_EXCEPTION);
				})	
			},
			//设备型号联动
			getDeviceCategory(){
				if(this.queryParam.brandCode == undefined)return;
				this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/devices/brands/'+this.queryParam.brandCode)
				.then( res => {
					if(res.data.success){
						this.deviceCategory= res.data.data;
					}else{
						this.openModalMsg(res.body.message);
					}
				}, res => {
						this.openModalMsg(res.body.message);
				}).catch( res => {
					this.openModalMsg(OPERATE_EXCEPTION);
				})	
			},
			//获取字典
			getUdc(){
				let udcType = [
					 DICTIONARY_MAP.IS_WIRELESS,  
					 DICTIONARY_MAP.OPERATOR_TYPE,
					 DICTIONARY_MAP.SIM_TYPE,
					 DICTIONARY_MAP.OBD_FLAG
				]
				let param = udcType.join(',');
				this.$http.get(process.env.API_ROOT + '/system/udcs',{params:{udcTypes: param}})
				.then(res => {
					if(res.data.success){		
					 	this.operatorList = getDictionaryFromArray(res.data.data, DICTIONARY_MAP.OPERATOR_TYPE);
						this.cardTypeList = getDictionaryFromArray(res.data.data,DICTIONARY_MAP.SIM_TYPE);
						this.wifiFlagList = getDictionaryFromArray(res.data.data,DICTIONARY_MAP.IS_WIRELESS);
					}else{
						this.openModalMsg(res.data.message);
					}
				}, res => {
					this.openModalMsg(res.data.message);
				}).catch( res => {
					this.openModalMsg(OPERATE_EXCEPTION);
				})		
			},
			//复选模式
			selectModel:function(){
				this.checkBox = !this.checkBox;
			},
			//全选
			selectAllField:function(){
				var _this = this;
				_this.posDeviceSelectArr = [];
                _this.fileInfoList.forEach(function(item, i) {
                    _this.posDeviceSelectArr.push(item);
                });
            },   
            //反选
			selectRevertField() {
				var _this = this;
				var newArr = [];
				_this.fileInfoList.forEach(function(item, i) {
					if (!_this.posDeviceSelectArr.includes(item)){
						newArr.push(item);
					}
                });
				this.posDeviceSelectArr = [];
				this.posDeviceSelectArr = newArr;
			},
			getPageNo:function(param){//从分页组件获取页码参数
				this.queryParam.page_index = param;
				this.getTableInfo();
			},
			// 消息弹出框相关 
			openModal(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#posdevice-list',this);
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		 classlist.toggleScroll('open','#posdevice-list',this);
        	},
        	closeModalMsg(){
        		this.closeModal("modalMsg");
        	},
        	openModalMsg(message){
        		this.messageStr = message;
        		this.openModal("modalMsg")
        	},
        	closeDirectiveModal(){//（指令表之下一步-取消）取消
        		this.closeModal("directiveModal");
        		this.stepIndex = 1;
        		this.delCmd = true
        	},
			//关联设备详情页面
			addDeviceTab: function(val,no,type,vehicleId) {
				const deviceid = val
				const obj = {
					name: deviceid + "-设备详情",
					id: 'PageDeviceDetail',
					route: '/indexhome/deviceDetail'+deviceid,
					No: 'device'+deviceid,
					params:{deviceid: deviceid,vehicleid:vehicleId,devicenum:no,devicetype:type}
				}
				this.$router.push({path:'/indexhome/deviceDetail'+ deviceid,query:{deviceid: deviceid,vehicleid:vehicleId,devicenum:no,devicetype:type}});
				this.$store.dispatch('addTab', obj);
			},
			//判断设备类型是否一致
			isRepeat(ary){
		        var bool=true;
	             for(var i=1,len=ary.length;i<len;i++){
	                 if(ary[i].categoryName!==ary[0].categoryName){bool=false}
	             }
	             return bool
			},
			//批量发送指令
			sentDirective:function(){
				if (this.posDeviceSelectArr.length==0){
					this.openModalMsg("设备未选择");
					return;
				}
				if((!this.isRepeat(this.posDeviceSelectArr))&&this.posDeviceSelectArr.length!=1){
					this.openModalMsg("应选择相同设备下发指令");
					return;
				}
				this.deviceTypeArr = [];
				for(var i in this.posDeviceSelectArr) {
				 	this.posDeviceSelectArr[i].deviceId
				 	this.deviceTypeArr.push(this.posDeviceSelectArr[i].deviceId)
				}
				this.loadingstatus = true;
				let param = this.deviceTypeArr.join(',');
				this.$http.get(process.env.API_ROOT + '/monitor/instruction/instus/menu/', {params: {deviceIds:param}})
				.then( res => {
					if(res.body.success){
						const resInfo = res.body.data;		
						this.cmdList = resInfo.cmdList;
						this.deviceList = resInfo.deviceList;
						this.loadingstatus = false;
						this.delCmd = false
						this.selectCmd.winId = ''
						this.selectCmd.cmdName = ''
						this.openModal("directiveModal");
					} else {
						this.openModalMsg(res.body.message);
						this.loadingstatus = false;
					}
				}, res => {
					this.openModalMsg(res.body.message);
					this.loadingstatus = false;
				}).catch( res => {
					this.openModalMsg(OPERATE_EXCEPTION);
					this.loadingstatus = false;
				})
				
			},
			backToFirst(){//（指令表之下一步-取消）取消
				this.closeModal("directiveModal");
        		this.stepIndex = 1;
			},
			nextstep:function(){//（指令表之下一步-取消）下一步
				if(this.selectCmd.cmdName==''){
					return
				}
				if (this.selectCmd.winId){
					this.stepIndex++;
				}else{
					this.stepIndex+=2;
					let that = this;
					this.sentCount = this.deviceList.filter(function(item, index, array){
						return item.categoryId == that.selectCmd.categoryId;
					});
				}
			},
			cancelCmd:function(){//（指令之下一步-取消）取消
				this.stepIndex--
			},
			nextCmd:function(arr){//（指令之下一步-取消）下一步
				this.stepIndex++;
				let that = this;
				this.sentCount = this.deviceList.filter(function(item, index, array){
					return item.categoryId == that.selectCmd.categoryId;
				});
				this.paramCmd = arr.join(',')
			},
			stopSend(){//(确认-取消)取消
				
				if(this.selectCmd.winId==''){
					this.stepIndex = 1
				}else{
					this.stepIndex = 2
				}
				this.sentCount = []
				
			},
			confirmToSend(){//(确认-取消)确认
				this.closeDirectiveModal()
				this.sendTime ++
				let p = this.dispatchIns()
				const that = this
				p.then(function(){
					if(that.selectCmd.winId=='InsOCARCaliMile' && that.sendTime==1 || that.sendTime == 2){
						that.openModal("directiveModal");
						that.stepIndex = 2
					}
				})
			},
			dispatchIns(){
				let dArr = []
				for(let i = 0,l = this.sentCount.length; i < l; i ++){
					dArr.push(this.sentCount[i].id)
				}
				const obj = {
					cmd:this.selectCmd.winId=='' ? this.selectCmd.clientCmd : this.paramCmd,
					cmdName:this.selectCmd.cmdName,
					cmdType:this.selectCmd.cmdType,
					deviceIds:dArr.join(','),
					source:'0'
				}
				const that = this
				let p = new Promise(function(resolve,reject){
					//'/monitor/instruction/instus/menu',obj
					//'/monitor/instruction/instus/menu?cmd=' + obj.cmd + '&cmdName=' + obj.cmdName + '&cmdType=' + obj.cmdType + '&deviceIds=' + obj.deviceIds + '&source=0'
					that.$http.post(process.env.API_ROOT +  '/monitor/instruction/instus/menu?cmd=' + obj.cmd + '&cmdName=' + obj.cmdName + '&cmdType=' + obj.cmdType + '&deviceIds=' + obj.deviceIds + '&source=0')
					.then(res=>{
						if(that.selectCmd.winId=='InsOCARCaliMile' && that.sendTime==1){
							resolve()
						}else{
							that.stepIndex = 1
							that.openModalMsg('派发指令成功');
							that.delCmd = true;
						}
					},res=>{
						if(that.selectCmd.winId=='InsOCARCaliMile' && that.sendTime==1){
							resolve()
						}else{
							that.openModalMsg(res.body.message);
						}
					})
					.catch(res=>{
						that.openModalMsg(OPERATE_EXCEPTION);
					})
				})
				return p
			}
		}
	};
</script>



// WEBPACK FOOTER //
// PagePosDeviceList.vue?4ee16585